import React from "react";
import { Link } from "react-router-dom";
import twitter from "../images/social_media/twitter.svg";
import facebook from "../images/social_media/facebook.svg";
import github from "../images/social_media/github.svg";
import linkedin from "../images/social_media/linkedin.svg";
import home from "../images/home-384.svg";

const SocialMedia = ({title}) => {

    return (
        <>
            <div className="flex flex-row h-1/6 justify-between items-center p-1">

                    <Link to="/" className="text-yellow-500">
                        <img src={ home } alt="home" srcset="" width={24} height={24} />
                    </Link>                    
                    <h1 className="text-2xl text-yellow-400">{title}</h1>
                    <div className="flex flex-row">
                        
                        <a href="https://www.facebook.com" target="_blank">
                            <img src={ facebook } alt="Facebook" width={24} height={24}/>
                        </a>
                        <a href="https://github.com/Mbicha" target="_blank">
                            <img src={ github } alt="Github" width={24} height={24}/>
                        </a>
                        <a href="https://www.linkedin.com/in/charles-mbithi-32728a166/" target="_blank">
                            <img src={ linkedin } alt="Linkedin" width={24} height={24}/>
                        </a>
                        <a href="https://twitter.com/charlesmbithi14" target="_blank">
                            <img src={ twitter } alt="Twitter" width={24} height={24}/>
                        </a>
                    </div>
            </div>
        </>
    )
}

export default SocialMedia;
